exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.cell-box .weui-cells{margin-top:2.13333vw;font-size:4vw\n}\n.cell-box .weui-cells::before,.cell-box .weui-cells::after{display:none\n}\n.cell-box .weui-cell{padding:5.33333vw 5.33333vw\n}\n.cell-box .weui-cell::before{left:5.33333vw;right:5.33333vw\n}\n.cell-box .weui-label,.cell-box .vux-label{color:#384369\n}\n.cell-box .weui-btn{display:inline-block;margin-left:5.33333vw;padding:0;width:21.33333vw;font-size:3.73333vw;border:0;color:#508cee;text-align:right;line-height:initial\n}\n", ""]);

// exports
